import { EditClientContractTermPresentation } from './presentations';

type Props = {
  /** 利用企業 ID（Screen 層でパース・検証済みの数値） */
  clientId: number;
  /** 企業契約期間 ID（Screen 層でパース・検証済みの数値） */
  termId: number;
};

/**
 * 企業契約期間 編集 Container コンポーネント
 *
 * ## 構成
 * - 本体表示（読み取り項目・フォーム要素配置）: T03（PEN-980）で実装予定
 * - バリデーション・API 送信処理: T04（PEN-981）で実装予定
 *
 * ## 後続チケット
 * - T03（PEN-980）: 本体表示（読み取り項目・フォーム要素配置）
 * - T04（PEN-981）: 編集機能本体・API 繋ぎ込み（Zod + 422 Toast + PUT hook）
 *
 * @param clientId - 利用企業 ID（Screen 層でパース・検証済みの数値）
 * @param termId - 企業契約期間 ID（Screen 層でパース・検証済みの数値）
 */
export const EditClientContractTerm: React.FC<Props> = () => <EditClientContractTermPresentation />;
